import { useCallback, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { toggleWishlistId, selectWishlistIds } from '../store/actions/wishlistActions';

/** Wishlist product ids — backed by Redux; same storage key as legacy Context. */
export function useWishlist() {
  const dispatch = useAppDispatch();
  const ids = useAppSelector(selectWishlistIds);

  const idSet = useMemo(() => new Set(ids), [ids]);

  const toggle = useCallback(
    (id) => {
      dispatch(toggleWishlistId(id));
    },
    [dispatch],
  );

  const isWishlisted = useCallback(
    (id) => idSet.has(String(id)),
    [idSet],
  );

  return useMemo(
    () => ({
      toggle,
      isWishlisted,
      count: ids.length,
      ids,
    }),
    [toggle, isWishlisted, ids],
  );
}
